import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import CultivationPlan from '@/components/CultivationPlan/CultivationPlan.vue';
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';
import Modal from "@/assets/common/Modal/Modal.vue";
import { Compact } from 'vue-color'
import Popup from "@/components/Popup/Popup.vue";
import { AgriFieldOnPlantingResponse, PlantingDetailResponse } from '@/types/APIResponse';
import { Crop, Planting, WeightUnit } from '@/types/Component';
import SelectCropModal from '@/assets/common/Modal/SelectCropModal/SelectCropModal.vue';
import SeedlingSelectModal from '@/assets/common/Modal/ItemSelectModal/SeedlingSelectModal/SeedlingSelectModal.vue';
import store from '@/assets/common/store/store';
import { formatGroupedUsageReasons } from '@/assets/common/services';

export type Field = {
    id: string;
    name: string;
    planted_area: number;
    display_start: string | null;
    display_end: string | null;
    using_area: number;
    last_planting: {
        id: string;
        name: string;
    };
    memo: string;
    file_id: Array<string>;
    checked?: boolean;
    isDeletable: boolean;
}

type PlantingPostModel = {
    name: string;
    basic_unit_id: string | null;
    agri_fields: Array<{id: string, using_area: number, using_seedlings: number}> | null;
    original_agri_fields: Array<{ id: string, updated: string | null }>;
    seedling_id: string | null;
    seedlings_amount: number;
    seedlings_quantity: number;
    seedling_unit_id: string | null;
    crop_id: string | null;
    color: string | null;
    memo: string;
    work_start_date: string | null;
    work_end_date: string | null;
    selected_works: Array<SelectedWorkDetail | SelectedWorkDeleteModel>;
    per_type: string | null;
    workers_budget: number | null;
    machines_budget: number | null;
    chemicals_budget: number | null;
    fertilizers_budget: number | null;
    materials_budget: number | null;
    income_prospect: number | null;
    total_yield: number | null;
    weight_unit: string | null;
    shipping_start_date: string | null;
    shipping_end_date: string | null;
    cultivation_method: string | null;
    is_hidden: boolean;
    changed_agrifield_ids: string[];
    // 楽観ロック用（新規作成時は未指定）
    updated?: string | null;
}

type SelectedWorkDetail = {
    work_item_id: string;
    update_type: string;
    plan_type: string; // 経過日数or期間
    working_start_date: string | null; // 期間のスタート
    working_end_date: string | null; // 期間のエンド
    selected_work_item_id: string | null; // 相対日数を出したい作業項目のID
    days: number | null; // 相対日数
    ago_or_later: string | null; // 日前or日後
    setting_type: string | null; // 合計時間or月別or旬別
    total_time: number | null; // 合計時間
    per_type: string | null; // 10aあたりor総時間
    attention_point: string | null;
    time_allocation: [
        {
            working_period: string;
            working_hour: number;
        }?
    ];
    related_machines: string[];
}

type SelectedWorkDeleteModel = {
    work_item_id: string;
    update_type: string;
}

interface SeedlingUnitType {
    id: string;
    unit: string;
}

type UsingAreaMessage = {
    id: string,
    message: string
}

@Component({
    components: {
        'vuejs-datepicker': Datepicker,
        CultivationPlan,
        SelectPlanting,
        Modal,
        Compact,
        Popup,
        SelectCropModal,
        SeedlingSelectModal
    }
})
export default class PlantingModal extends Vue {

    @Prop({ default: false })
    isShow!: boolean;

    closeModal() {
        if (store.getters.isInputChanged && this.hiddenSwitchBtn === false) {
            const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
            if (confirm) {
                store.dispatch("doUpdateIsInputChanged", false);
                this.$emit('update:isShow', false);
            }
        }else{
            this.hiddenSwitchBtn = false
            this.$emit('update:isShow', false);
        }
    }

    @Prop()
    id?: string

    @Prop()
    mode?: string

    @Prop({ default: false })
    readonly isRefresh!: boolean;

    @Watch("isShow")
    handlePlantingModal() {
        if(this.id) {
            this.editTargetId = this.id
        } else {
            this.editTargetId = ''
        }
        if(this.mode) {
            this.modeType = this.mode
        }
        this.init()
    }

    @Watch('isShow')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    @Prop({ default: ()=>[] })
    private plantings!: Array<Planting>

    private wariai = 15

    private modeType = '';
    private editTargetId = '';
    private headerTitle = '作付新規作成';
    private subTitle = '';
    private isCreateMode = false;
    private isEditMode = false;
    private showFieldModal = false;
    private showCropsModal = false;
    private showSeedlingModal = false;
    private isLoading = false
    private selectedSeedlingUnit ='';
    private beforePlantingName = ''
    private loadedPlanting = false
    private defaultWeightUnit = {
        id: null,
        name: 'kg',
        weight_per_unit: 1
    }
    private defaultPerType = '10a'
    private apiBaseUrl = '/plantings'
    private baseUrl = '/master/plantings'
    private plantingIsHidden = false
    private isDeleting = false
    private colors = [
        'rgb(255, 53, 53)',
        'rgb(209, 108, 21)',
        'rgb(113, 175, 66)',
        'rgb(0, 159, 230)',
        'rgb(23, 79, 158)',
        'rgb(75, 52, 139)',
        'rgb(255, 51, 153)',
        'rgb(51, 255, 255)',
        'rgb(51, 255, 51)',
        'rgb(255, 153, 0)',
        'rgb(255, 153, 153)',
        'rgb(191, 191, 191)'
    ]

    private isColorPickerVisible = false
    private hiddenSwitchBtn = false

    private getField: any = [
        {
            id: '',
            name: '',
            plantedArea: 0,
            plantings: [{
                id: '',
                name: '',
                crop:
                {
                    id: '',
                    name: ''
                },
                cultivationPlan:
                {
                    workStart: new Date(),
                    workEnd: new Date()
                }
            }]
        }
    ];
    private search = '';
    private checkedCrops: Crop | null = null;
    private saveCheckedCrops: Crop | null = null;
    private checkedField: Array<Field> = [];
    private saveCheckedField: any[] = [];
    private plantedAreaSum = 0;

    private calcCheckedField: Array<Field> = []
    private calcFieldList: Array<Field> = []
    private calcFieldAreaSum = 0

    private defaultPlantingDetail: PlantingDetailResponse = {
        id: '',
        name: '',
        basic_unit_id: null,
        agri_fields: null,
        seedling: null,
        crop: {
            id:'',
            name:'',
            phonetic: ''
        },
        color: 'rgb(255, 53, 53)',
        memo: '',
        work_start_date: null,
        work_end_date: null,
        selected_works: [],
        per_type: this.defaultPerType,
        workers_budget: 0,
        machines_budget: 0,
        chemicals_budget: 0,
        fertilizers_budget: 0,
        materials_budget: 0,
        income_prospect: 0,
        is_hidden: false,
        total_yield: 0,
        weight_unit: this.defaultWeightUnit,
        shipping_start_date: null,
        shipping_end_date: null,
        cultivation_method: ''
    }
    private plantingDetail: PlantingDetailResponse = this.defaultPlantingDetail
    private initPlanting: PlantingDetailResponse = this.defaultPlantingDetail

    private fieldList: Array<Field> = []
    private weightUnits: Array<WeightUnit> = []
    private seedlingUnits: Array<SeedlingUnitType> = []

    private showSelectPlanting = false
    private plantingCopySuffix = ''

    private usingAreaMessageList: UsingAreaMessage[] = []

    private changedAgriFieldIds: string[] = [];
    // 楽観チェック用：画面表示時点の作付圃場のスナップショット（未選択になった圃場＝削除、DBにない圃場＝追加として扱う）
    private originalAgriFieldPlantings: Array<{ id: string, updated: string | null }> = [];

    workRecordCultivationRecordFlag = false;

    ja = ja
    datepicker1 = new Date();
    datepicker2 = new Date();
    datePickerFormat = 'yyyy-MM-dd';

    get checkedSeedling(): boolean {
        return this.plantingDetail.seedling !== null && this.plantingDetail.seedling !== undefined
    }

    // 圃場リスト
    get searchField(): any {
        const calcFieldList = this.fieldList.filter((field: any) => {
            const start = moment(this.datepicker1).startOf('day')
            const displayStart = moment(field.display_start).startOf('day')
            const displayEnd = moment(field.display_end).startOf('day')
            const end = moment(this.datepicker2).startOf('day')
            const isMoment = (!displayStart.isValid() || displayStart.isSameOrBefore(end)) && (!displayEnd.isValid() || displayEnd.isSameOrAfter(start))

            return field.name.includes(this.search) && isMoment
        })
        return calcFieldList
    }

    // 選択した圃場の合計面積計算
    get checkedFieldAreaSum(): number {
        this.calcFieldAreaSum = 0
        this.calcCheckedField.forEach((item: any) => {
            // 小数点同士の計算は誤差が生じるため、整数に直して計算する
            const arrayA = String(this.calcFieldAreaSum).split(".")
            const arrayB = String(item.planted_area).split(".")
            let calcA = 0
            let calcB = 0
            let calcC = 0
            let calcD = 0
            let resultStr = "0"
            if(arrayA.length > 1 && arrayB.length > 1) {
                const digitA = arrayA[1].length
                const digitB = arrayB[1].length
                if(digitA > digitB) {
                    arrayB[1] = arrayB[1].concat('0'.repeat(digitA - digitB))
                } else {
                    arrayA[1] = arrayA[1].concat('0'.repeat(digitB - digitA))
                }
            }
            calcA = Number(arrayA[0])
            if(arrayA.length > 1) {
                calcB = Number(arrayA[1])
            }
            calcC = Number(arrayB[0])
            if(arrayB.length > 1) {
                calcD = Number(arrayB[1])
            }
            resultStr = String(calcA + calcC)
            if(calcB + calcD != 0) {
                resultStr = resultStr + "." + String(calcB + calcD)
            }
            this.calcFieldAreaSum = Number(resultStr)
        })
        return this.calcFieldAreaSum
    }

    get refs(): any {
        return this.$refs;
    }

    private init() {
        this.datepicker1 = new Date()
        this.datepicker2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
        this.usingAreaMessageList = []
        this.plantingCopySuffix = ''
        if(this.modeType === 'edit'){
            this.isCreateMode = false
            this.isEditMode = true
            this.headerTitle = '作付編集'
            this.subTitle =''
            this.getPlantingDetail(this.editTargetId)
        } else {
            this.isCreateMode = true
            this.isEditMode = false
            this.headerTitle = '作付新規作成'
            this.subTitle = this.modeType === 'copy' ? '（複製）': '';
            this.checkedField = [];
            this.originalAgriFieldPlantings = [];
            this.checkedCrops = null
            this.plantingDetail = Object.assign({}, this.defaultPlantingDetail)
            this.getFieldList()
            this.getWeightUnits()
            this.loadedPlanting = true
            if (this.editTargetId) {
                this.getPlantingDetail(this.editTargetId)
            }
        } 
    }

    // 作付詳細単品取得
    private getPlantingDetail(plantingId: string) {
        this.isLoading = true
        this.editTargetId = plantingId
        this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${this.editTargetId}`)
            .then((res)=>{
                this.initPlanting = res
                this.beforePlantingName = res.name

                this.originalAgriFieldPlantings = res.agri_fields != null
                    ? res.agri_fields.map((af: any) => ({ id: af.id, updated: af.updated ?? null }))
                    : []
                if(res.agri_fields != null) {
                    this.getSeedlingUnits();
                    this.checkedField = res.agri_fields.map((af: any) => ({
                        id: af.id, name: af.name, is_hidden: af.is_hidden, planted_area: af.planted_area, isDeletable : af.isDeletable
                    }))
                    this.calcCheckedField = this.checkedField
                    this.plantedAreaSum = this.checkedFieldAreaSum
                    res.agri_fields = res.agri_fields.map((agriField: any) => ({
                        id: agriField.id,
                        is_hidden: agriField.is_hidden,
                        name: agriField.name,
                        planted_area: agriField.planted_area != null ? this.$apiClient.exponentToDecimal(agriField.planted_area) : null,
                        remaining_area: agriField.remaining_area != null ? this.$apiClient.exponentToDecimal(agriField.remaining_area) : null,
                        using_seedlings: agriField.using_seedlings != null ? this.$apiClient.exponentToDecimal(agriField.using_seedlings) : null,
                        using_area: agriField.using_area != null ? this.$apiClient.exponentToDecimal(agriField.using_area) : null,
                        isDeletable: this.modeType == 'copy' ? true : agriField.isDeletable
                    }))
                    const agriFields = this.checkedField.map(af => af.id)
                    if (this.modeType !== 'edit' && this.initPlanting.work_start_date && this.initPlanting.work_end_date && agriFields && agriFields.length !== 0) {
                        this.updateUsingArea(agriFields, this.initPlanting.work_start_date, this.initPlanting.work_end_date)
                    }
                }
                this.plantingDetail = res
                this.plantingDetail.name += this.plantingCopySuffix
                
                if(this.mode == "copy"){
                this.plantingDetail.name = this.plantingDetail.name +'のコピー'
                }
                
                if(res.weight_unit && res.weight_unit.id) {
                    this.plantingDetail.weight_unit = res.weight_unit
                } else {
                    this.plantingDetail.weight_unit = this.defaultWeightUnit
                }
                if(!res.per_type) {
                    this.plantingDetail.per_type = this.defaultPerType
                }

                this.plantingIsHidden = res.is_hidden
                this.checkedCrops = res.crop
                this.getFieldList()
                this.getWeightUnits();
                this.loadedPlanting = true
            })
            .finally(() => {
                this.isLoading = false
            })
    }

    // 圃場一覧の取得
    getFieldList(){
        this.fieldList = []
        this.$apiClient.doRequest('get', '/agri_fields')
            .then((res)=>{
                const agriFields: Array<Field> = res.agri_fields;

                this.fieldList = agriFields.map(item => ({
                    ...item,
                    checked: this.checkedField.some(x => x.id === item.id),
                    isDeletable: this.plantingDetail?.agri_fields?.find((pf: any) => pf.id === item.id)?.isDeletable ?? true
                }))
            })
    }

    // 単位一覧の取得
    getWeightUnits() {
        this.$apiClient.doRequest('get', '/weight_units?with_hidden=true').then(res => {
            const weightUnits: Array<WeightUnit> = res.weight_units;
            this.weightUnits = weightUnits
        }).catch(() => {
            return
        })
    }

    private getSeedlingUnits() {
        this.$apiClient.doRequest('get', '/plantings/seedling_units').then((res )=> {
            const seedlingUnits: Array<SeedlingUnitType> = res.seedling_units;
            this.seedlingUnits = seedlingUnits
            const seedlingUnit = this.seedlingUnits?.find((unit) => unit.id === this.plantingDetail.seedling?.seedling_unit_id)
            this.selectedSeedlingUnit = seedlingUnit? seedlingUnit?.unit : ""
        }).catch(() => {
            return
        })
    }

    private updateSeedlingUnit(e: any) {
        const unitObj = this.seedlingUnits?.find((unit) => unit.id === e.target.value);
        this.selectedSeedlingUnit=unitObj?unitObj.unit:"";
        this.inputChanged()
    }

    // 作付の履歴
    checkHistory(field: Field) {
        this.getField = {}
        const agriFieldId = field.id
        // const agriFieldId = "9e5c591d-6d1e-11eb-bea6-0ae6befda69e"
        this.$apiClient.doRequest('get', `/agri_fields/${agriFieldId}`)
            .then((res)=>{
                const resField: Field = res
                const plantings: any[] = []
                if(res.plantings != null) {
                    res.plantings.forEach((item: any) => {
                        const cultivationPlan = (item.cultivation_plan == null || item.cultivation_plan.work_start == null || item.cultivation_plan.work_end == null) ? '指定なし' : new Date(item.cultivation_plan.work_start).getFullYear() + '年' + (new Date(item.cultivation_plan.work_start).getMonth()+1) + '月 ～' +  new Date(item.cultivation_plan.work_end).getFullYear() + '年' + (new Date(item.cultivation_plan.work_end).getMonth()+1) + '月'
                        plantings.push({
                            id: item.id,
                            name: item.name,
                            cultivation_plan: cultivationPlan
                        })
                    });

                }

                this.getField = {
                    id: res.id,
                    name: res.name,
                    planted_area: res.planted_area,
                    plantings: plantings
                }
            })
    }

    validate() {
        let errmsg: string[] = []

        // 名前の入力
        if(!this.plantingDetail.name.trim()) {
            errmsg.push("作付名を入力してください")
        }
        // 名前の長さ
        else if(this.plantingDetail.name.length > 255) {
            errmsg.push(`作付名は255文字以内で入力してください（現在は${this.plantingDetail.name.length}文字）`)
        }
        // 重複チェック
        else if(this.plantings.some(item => {
            if(this.modeType === 'edit') {
                return item.name == this.plantingDetail.name && this.beforePlantingName != this.plantingDetail.name
            } else {
                return item.name == this.plantingDetail.name
            }
        })) {
            errmsg.push("作付名が重複しています。作付名は他と重複しないものを設定してください")
        }
        if(!this.checkedCrops) {
            errmsg.push("作目を選択してください")
        }
        if(!this.dateFormatCheck(this.plantingDetail.work_start_date) || !this.dateFormatCheck(this.plantingDetail.work_end_date)) {
            errmsg.push("栽培期間を入力してください")
        }
        if(moment(this.plantingDetail.work_start_date).isAfter(moment(this.plantingDetail.work_end_date))) {
            errmsg.push("栽培期間の開始日は終了日以前で設定してください")
        }
        if(this.plantingDetail.cultivation_method && this.plantingDetail.cultivation_method.length > 255) {
            errmsg.push(`栽培法は255文字以内で入力してください（現在は${this.plantingDetail.cultivation_method.length}文字）`)
        }
        if(this.plantingDetail.memo && this.plantingDetail.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.plantingDetail.memo.length}文字）`)
        }

        if(this.usingAreaMessageList.length !== 0) {
            const message = this.usingAreaMessageList.map(uam => (uam.message))
            errmsg = errmsg.concat(message)
        }

        let seedlingSum = 0
        this.plantingDetail.agri_fields?.forEach(af => {
            if(af.using_seedlings !== null && af.using_seedlings !== undefined && af.using_seedlings.toString() !== ''){
                const usageStr = af.using_seedlings.toString().split('.')
                if((af.using_seedlings< 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                    errmsg.push(`利用品種数は0より大きい整数部7桁小数部2桁までの数値を入力してください（圃場：${af.name}）`)
                }
                seedlingSum += +af.using_seedlings
            }
            else {
                af.using_seedlings = 0
            }
            if (af.using_area === null || af.using_area === undefined || af.using_area <= 0) {
                errmsg.push(`使用面積は0より大きい値を入力してください（圃場：${af.name}）`);
            } else {
                const areaStr = af.using_area.toString().split('.');
                const integerPart = areaStr[0];
                const decimalPart = areaStr[1] || '';
                if (integerPart.length > 7 || decimalPart.length > 2) {
                    errmsg.push(`使用面積は整数部7桁、小数部2桁までの数値を入力してください（圃場：${af.name}）`);
                }
            }
        })

        if(this.plantingDetail.seedling !== null && this.plantingDetail.seedling !== undefined) {
            if(this.plantingDetail.seedling.seedlings_amount.toString() !== '') {
                if(this.plantingDetail.seedling.seedlings_amount < 0) {
                    errmsg.push("品種（種苗）購入金額に0以上を入力してください")
                }
                else if(!(/^\d+$/.test(this.plantingDetail.seedling.seedlings_amount.toString()))) {
                    errmsg.push("品種（種苗）購入金額に整数を入力してください")
                }
            }
            else {
                this.plantingDetail.seedling.seedlings_amount = 0
            }
            if(this.plantingDetail.seedling.seedlings_quantity?.toString() !== '' && this.plantingDetail.seedling.seedlings_quantity !== null) {
                const usageStr = this.plantingDetail.seedling.seedlings_quantity.toString().split('.')
                if((this.plantingDetail.seedling.seedlings_quantity < 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                    errmsg.push("品種（種苗）購入量は0より大きい整数部7桁小数部2桁までの数値を入力してください")
                }
            }
            else {
                this.plantingDetail.seedling.seedlings_quantity = 0
            }
            if(this.plantingDetail.seedling.seedlings_quantity < seedlingSum) {
                errmsg.push("圃場の利用品種数が品種（種苗）購入量を超えています")
            }
        }
        else {
            this.plantingDetail.seedling = null
        }

        let workersBudget = 0
        if(this.plantingDetail.workers_budget !== null && this.plantingDetail.workers_budget.toString() !== '') {
            if(this.plantingDetail.workers_budget < 0) {
                errmsg.push("雇用費予算に0以上を入力してください")
            }else if(!(/^\d+$/.test(this.plantingDetail.workers_budget.toString()))) {
                errmsg.push("雇用費予算に整数を入力してください")
            }
            workersBudget = +this.plantingDetail.workers_budget
        } else {
            this.plantingDetail.workers_budget = null
        }
        let machinesBudget = 0
        if(this.plantingDetail.machines_budget !== null && this.plantingDetail.machines_budget.toString() !== '') {
            if(this.plantingDetail.machines_budget < 0 ) {
                errmsg.push("動力光熱費予算に0以上を入力してください")
            }else if(!(/^\d+$/.test(this.plantingDetail.machines_budget.toString()))) {
                errmsg.push("動力光熱費予算に整数を入力してください")
            }
            machinesBudget = +this.plantingDetail.machines_budget
        } else {
            this.plantingDetail.machines_budget = null
        }
        let chemicalsBudget = 0
        if(this.plantingDetail.chemicals_budget !== null && this.plantingDetail.chemicals_budget.toString() !== '') {
            if(this.plantingDetail.chemicals_budget < 0) {
                errmsg.push("農薬衛生費予算に0以上を入力してください")
            }else if(!(/^\d+$/.test(this.plantingDetail.chemicals_budget.toString()))) {
                errmsg.push("農薬衛生費予算に整数を入力してください")
            }
            chemicalsBudget = +this.plantingDetail.chemicals_budget
        } else {
            this.plantingDetail.chemicals_budget = null
        }
        let fertilizersBudget = 0
        if(this.plantingDetail.fertilizers_budget !== null && this.plantingDetail.fertilizers_budget.toString() !== '') {
            if(this.plantingDetail.fertilizers_budget < 0) {
                errmsg.push("肥料費予算に0以上を入力してください")
            }else if(!(/^\d+$/.test(this.plantingDetail.fertilizers_budget.toString()))) {
                errmsg.push("肥料費予算に整数を入力してください")
            }
            fertilizersBudget = +this.plantingDetail.fertilizers_budget
        } else {
            this.plantingDetail.fertilizers_budget = null
        }
        let materialsBudget = 0
        if(this.plantingDetail.materials_budget !== null && this.plantingDetail.materials_budget.toString() !== '') {
            if(this.plantingDetail.materials_budget < 0) {
                errmsg.push("資材費予算に0以上を入力してください")
            }else if(!(/^\d+$/.test(this.plantingDetail.materials_budget.toString()))) {
                errmsg.push("資材費予算に整数を入力してください")
            }
            materialsBudget = +this.plantingDetail.materials_budget
        } else {
            this.plantingDetail.materials_budget = null
        }
        if(this.plantingDetail.income_prospect == null || this.plantingDetail.income_prospect.toString() == '') {
            errmsg.push("収入見込を入力してください")
        }

        // 以下栽培計画非表示化による追記
        /*
        栽培計画非表示化によるコメントアウト
        const caltivationPlan: Planting = this.refs.cultivationPlan.savePlanting()
        const uploadImages: Array<{workItemId: string, file: File}> = this.refs.cultivationPlan.uploadImages
        const deletedImages: Array<{workItemId: string, fileId: string}> = this.refs.cultivationPlan.deletedImages
        const selectedWorks: Array<SelectedWorkDetail | SelectedWorkDeleteModel> = caltivationPlan.selected_works.map((item)=>{
            if(item.update_type == 'DELETE') {
                return {
                    work_item_id: item.work_item.id,
                    update_type: item.update_type
                }
            } else {
                return {
                    work_item_id: item.work_item.id,
                    plan_type: item.plan_type,
                    update_type: item.update_type,
                    working_start_date: item.plan_type == 'ELAPSED_DAYS'? null : item.working_start_date,
                    working_end_date: item.plan_type == 'ELAPSED_DAYS'? null : item.working_end_date,
                    selected_work_item_id: item.selected_work_item_id,
                    days: item.days,
                    image_id: item.image_id,
                    ago_or_later: item.ago_or_later,
                    setting_type: item.setting_type,
                    total_time: item.total_time,
                    per_type: item.per_type,
                    attention_point: item.attention_point,
                    time_allocation: item.time_allocation,
                    related_machines: item.related_machines.map(machine => machine.id)
                }
            }
        })


        // 栽培計画バリデーション
        if(!this.refs.cultivationPlan.validationCultivationPlan()) {
            return false
        }
        */

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        } else {
            return true;
        }
    }

    save() {
        const isValid = this.validate();
        if(!isValid) {
            return false;
        }
        const caltivationPlan = this.plantingDetail
        const checkedFieldIds = this.plantingDetail.agri_fields
        ? this.plantingDetail.agri_fields.map((item)=>({id: item.id, using_area: item.using_area, using_seedlings: item.using_seedlings}))
            : []
        const data: PlantingPostModel = {
            name: this.plantingDetail.name,
            basic_unit_id: this.plantingDetail.basic_unit_id,
            agri_fields: checkedFieldIds,
            original_agri_fields: this.originalAgriFieldPlantings,
            seedling_id: this.plantingDetail.seedling ? this.plantingDetail.seedling.id : null,
            seedlings_amount: this.plantingDetail.seedling ? this.plantingDetail.seedling.seedlings_amount : 0,
            seedlings_quantity: this.plantingDetail.seedling ? this.plantingDetail.seedling.seedlings_quantity : 0,
            seedling_unit_id: this.plantingDetail.seedling && this.plantingDetail.seedling.seedling_unit_id !== 'null' ? this.plantingDetail.seedling.seedling_unit_id : null,
            crop_id:  this.checkedCrops?.id || null , // 作目のID
            color: this.plantingDetail.color, // 作付の色
            memo: this.plantingDetail.memo, // メモ
            work_start_date: caltivationPlan.work_start_date,
            work_end_date: caltivationPlan.work_end_date,
            // selected_works: selectedWorks,// 作付内で選択されている作業項目,
            selected_works: [], // 栽培計画非表示化による追記
            per_type: caltivationPlan.per_type,
            workers_budget: this.plantingDetail.workers_budget,
            machines_budget: this.plantingDetail.machines_budget,
            chemicals_budget: this.plantingDetail.chemicals_budget,
            fertilizers_budget: this.plantingDetail.fertilizers_budget,
            materials_budget: this.plantingDetail.materials_budget,
            income_prospect: this.plantingDetail.income_prospect,
            total_yield: caltivationPlan.total_yield,
            weight_unit: caltivationPlan.weight_unit.id,
            shipping_start_date: caltivationPlan.shipping_start_date,
            shipping_end_date: caltivationPlan.shipping_end_date,
            cultivation_method: this.plantingDetail.cultivation_method, // 栽培法
            is_hidden: false,
            changed_agrifield_ids: this.changedAgriFieldIds,
            updated: this.plantingDetail.updated
        }

        this.isLoading = true
        if(this.modeType === 'edit') {
            const result = window.confirm("内容を上書きして保存します。よろしいですか？")
            if(!result) {
                this.isLoading = false
                return false;
            }

            if(this.workRecordCultivationRecordFlag){
                const result = window.confirm("圃場面積を変更した場合、栽培履歴、作業記録で、使用した農薬・肥料の使用量は変更されません。")
                if(!result) {
                    this.isLoading = false
                    return false;
                }

            }


            // API連携(作付更新)
            this.$apiClient.doRequest("put", `${this.apiBaseUrl}/${this.editTargetId}`, data)
                .then(res => {
                    if (res && res.message) {
                        window.alert(res.message)
                        return
                    }

                    const promise: any = []
                    /*
                    栽培計画非表示化によるコメントアウト
                    if(uploadImages.length > 0){
                        uploadImages.forEach(image => {
                            promise.push(this.$apiClient.fileUpload(`${this.apiBaseUrl}/${res.id}/plans/${image.workItemId}/images`, image.file))
                        });
                    }
                    if(deletedImages.length > 0){
                        deletedImages.forEach(image => {
                            promise.push(this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${res.id}/plans/${image.workItemId}/images/${image.fileId}`))
                        });
                    }
                    */

                    Promise.all(promise).then(() => {
                        this.$toasted.success('変更を保存しました。')
                        this.$emit('update:isRefresh', true);
                        this.changedAgriFieldIds = [];
                        this.workRecordCultivationRecordFlag = false;
                        this.$store.dispatch('doUpdateIsInputChanged', false);
                        this.closeModal()
                    })
                })
                .catch(error => {
                    this.$toasted.error('保存に失敗しました。')
                })
                .finally(() => {
                    this.isLoading = false
                })
        } else {
            // API連携(作付作成)
            this.$apiClient.doRequest("post", this.apiBaseUrl, data)
                .then(res => {
                    if (res && res.message) {
                        window.alert(res.message)
                        return
                    }

                    const promise: any = []
                    /*
                    栽培計画非表示化によるコメントアウト
                    if(uploadImages.length > 0){
                        uploadImages.forEach(image => {
                            promise.push(this.$apiClient.fileUpload(`${this.apiBaseUrl}/${res.id}/plans/${image.workItemId}/images`, image.file))
                        });
                    }
                    */
                    Promise.all(promise).then(() => {
                        this.$toasted.success('保存しました。')
                        this.$emit('update:isRefresh', true);
                        this.changedAgriFieldIds = [];
                        this.workRecordCultivationRecordFlag = false;
                        this.$store.dispatch('doUpdateIsInputChanged', false);
                        this.closeModal()
                    })
                })
                .catch(error => {
                    this.$toasted.error('保存に失敗しました。')
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }

    cancel() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか？');
            if (!result) {
                return false;
            }
        }
        this.changedAgriFieldIds = [];
        this.workRecordCultivationRecordFlag = false;
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.init()
    }

    switchDisplayPlanting() {
        const isValid = this.validate();
        if(!isValid) {
            return false;
        }
        // 表示/非表示ボタンを押したときの挙動
        const displayMessage = !this.plantingIsHidden? '非表示にし' : '表示状態に戻し'
        const result = window.confirm(`${this.beforePlantingName}を${displayMessage}ます。よろしいですか？`)
        if(!result) {
            return false;
        }
        this.hiddenSwitchBtn = true;

        this.isLoading = true
        // API連携（作付の表示切り替え）
        const updatedParam = this.plantingDetail.updated ? `&updated=${encodeURIComponent(this.plantingDetail.updated)}` : ''
        this.$apiClient.doRequest("put", `${this.apiBaseUrl}/${this.editTargetId}/display?is_hidden=${!this.plantingIsHidden}${updatedParam}`)
            .then(response => {
                if (response && response.message) {
                    window.alert(response.message)
                    this.hiddenSwitchBtn = false
                    return
                }
                this.$toasted.success(!this.plantingIsHidden ?  `非表示に変更しました。` :`表示に変更しました。`)
                this.$emit('update:isRefresh', true);
                this.closeModal()
            })
            .catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
    }

    deletePlanting() {
        if (this.isDeleting) {
            return
        }
        const result = window.confirm(`${this.beforePlantingName}を削除します。よろしいですか？`)
        if (!result) {
            return
        }
        this.isDeleting = true
        this.hiddenSwitchBtn = true
        this.isLoading = true
        const query = this.plantingDetail.updated ? `?updated=${encodeURIComponent(this.plantingDetail.updated)}` : ''
        this.$apiClient.doRequest("delete", `${this.apiBaseUrl}/${this.editTargetId}${query}`)
            .then((res) => {
                if (res && res.message) {
                    window.alert(res.message)
                    this.hiddenSwitchBtn = false
                    return
                }
                this.$toasted.success('削除しました。')
                this.$emit('update:isRefresh', true);
                this.closeModal()
            })
            .catch(() => {
                this.$toasted.error('削除に失敗しました。')
                this.hiddenSwitchBtn = false
            })
            .finally(() => {
                this.isDeleting = false
                this.isLoading = false
            })
    }

    openFieldModal() {
        // 圃場モーダルデフォルト作業期間セット
        if(!this.dateFormatCheck(this.plantingDetail.work_start_date) || !this.dateFormatCheck(this.plantingDetail.work_end_date)) {
            window.alert("栽培期間を入力してください。")
            return false
        } else {
            this.datepicker1 = moment(this.plantingDetail.work_start_date).toDate()
            this.datepicker2 = moment(this.plantingDetail.work_end_date).toDate()
        }
        this.calcCheckedField = this.checkedField

        this.showFieldModal = true
    }

    async saveFieldModal() {
        const newFieldIds = new Set(this.calcCheckedField.map(cf => cf.id))
        const removedFields = this.modeType === 'edit'
            ? this.checkedField.filter(cf => !newFieldIds.has(cf.id))
            : []

        const blockedGroups: Array<{ name: string, reasons: string[] }> = []
        for (const removed of removedFields) {
            const url = `${this.apiBaseUrl}/check_agri_field_deletable/${this.plantingDetail.id}/${removed.id}`
            const reasons: string[] = await this.$apiClient.doRequest("get", url)
            if (reasons && reasons.length > 0) {
                blockedGroups.push({ name: removed.name, reasons })
            }
        }
        if (blockedGroups.length > 0) {
            window.alert(formatGroupedUsageReasons(blockedGroups))
            this.calcCheckedField = this.checkedField
            return
        }

        this.checkedField = this.calcCheckedField
        this.plantedAreaSum = this.calcFieldAreaSum
        this.search = ''

        const agriFields = this.checkedField.map(af => af.id)
        const workStartDate = this.plantingDetail.work_start_date
        const workEndDate = this.plantingDetail.work_end_date
        if(workStartDate && workEndDate) {
            this.updateUsingArea(agriFields, workStartDate, workEndDate)
        }

        this.showFieldModal = false
    }

    cancelFieldModal() {
        this.calcCheckedField = this.checkedField
        this.showFieldModal = false
        this.search = ''
        this.getField = {}
    }
    async selectedFieldDelete(fieldId: string) {
        const existedBeforeRemoval = this.checkedField.some(cf => cf.id === fieldId);
        if (this.modeType == "edit" && existedBeforeRemoval) {
            const url = `${this.apiBaseUrl}/check_agri_field_deletable/${this.plantingDetail.id}/${fieldId}`;
            const reasons: string[] = await this.$apiClient.doRequest("get", url);
            if (reasons && reasons.length > 0) {
                const fieldName = this.checkedField.find(cf => cf.id === fieldId)?.name ?? fieldId
                window.alert(formatGroupedUsageReasons([{ name: fieldName, reasons }]));
                return;
            }
        }
        this.checkedField = this.checkedField.filter(cf => cf.id !== fieldId)
        if(this.plantingDetail.agri_fields) {
            this.plantingDetail.agri_fields = this.plantingDetail.agri_fields.filter(af => af.id !== fieldId)
        }
        this.calcCheckedField = this.checkedField
        this.plantedAreaSum = this.checkedFieldAreaSum
        this.usingAreaMessageList = this.usingAreaMessageList.filter(uam => uam.id !== fieldId)
        this.inputChanged()
    }

    // 品種（種苗）モーダル関連
    openSeedlingModal() {
        this.showSeedlingModal = true
        this.$emit('crop-modal-inert',true)
        this.inputChanged()
    }

    cancelSeedling() {
        const newAgriFields = this.plantingDetail.agri_fields?.map(af => ({...af, using_seedlings: 0}))
        this.plantingDetail = {
            ...this.plantingDetail,
            seedling: null,
            agri_fields: newAgriFields ? newAgriFields : null
        }
        this.selectedSeedlingUnit='';
        this.inputChanged()
    }

    saveSeedlingModal(seedling: any): void {
        this.$apiClient.doRequest('get', `/seedlings/${seedling.id}`)
            .then((res) => {
                this.plantingDetail = {
                    ...this.plantingDetail,
                    seedling: {
                        id: seedling.id,
                        name: seedling.name,
                        seedlings_quantity: 0,
                        seedlings_amount: 0,
                        seedling_unit_id: null,
                    },
                    crop: {...res.crop}
                }
                this.selectedSeedlingUnit='';
                this.checkedCrops = res.crop
                this.getSeedlingUnits()
            })
            .finally(() => {
                this.showSeedlingModal = false
            })
    }

    cancelSeedlingModal() {
        this.showSeedlingModal = false
    }

    // 作目モーダル関連
    openCropsModal() {
        this.showCropsModal = true
        this.$emit('crop-modal-inert',true)
        this.saveCheckedCrops = this.checkedCrops
    }
    saveCropsModal(crop: Crop) {
        this.checkedCrops = crop
        this.showCropsModal = false
        this.saveCheckedCrops = this.checkedCrops
    }
    cropsModalCancel() {
        this.showCropsModal = false
    }

    @Watch('showCropsModal')
    onCropModalChanged(val: boolean) {
        this.$emit('crop-modal-inert', val)
    }

    @Watch('showCropsModal')
    onSeedlingModalChanged(val: boolean) {
        this.$emit('seedling-modal-inert', val)
    }


    // 作付コピーモーダル
    showPlantingCopyModal() {
        this.showSelectPlanting = true;
    }

    catchPlanting(plantingId: string) {
        this.plantingCopySuffix = 'のコピー'
        this.getPlantingDetail(plantingId)
    }

    closeSelectPlantingModal() {
        this.showSelectPlanting = false;
    }

    updateColor(color: any) {
        this.plantingDetail.color = `rgba(${color.rgba.r},${color.rgba.g},${color.rgba.b})`
    }

    private areaValueToRate(plantedArea: number, area: number): number {
        return Number(plantedArea) !== 0 ? Math.round((area / plantedArea) * 10000) / 100 : 0
    }

    private areaRateToValue(plantedArea: number, areaRate: number) {
        let result = plantedArea * (areaRate / 100)
        let resultStr = String(result)
        if(resultStr.indexOf('.') !== -1) {
            const splitDecimal = resultStr.split('.')
            resultStr = `${splitDecimal[0]}.${splitDecimal[1].substring(0, 9)}`
            result = Number(resultStr)
        }
        return result
    }

    private updateWorkStartDate(e: Event) {
        const preWorkStartDate = this.plantingDetail.work_start_date
        const target = e.target
        if (target instanceof HTMLInputElement) {
            const agriFields = this.plantingDetail.agri_fields?.map(af => af.id)
            this.plantingDetail.work_start_date = target.value
            if (this.plantingDetail.work_start_date && this.plantingDetail.work_end_date && agriFields && agriFields.length !== 0) {
                this.updateUsingArea(agriFields, this.plantingDetail.work_start_date, this.plantingDetail.work_end_date)
            }
        }
        this.inputChanged()
    }

    private updateWorkEndDate(e: Event) {
        const preWorkEndDate = this.plantingDetail.work_end_date
        const target = e.target
        if (target instanceof HTMLInputElement) {
            const agriFields = this.plantingDetail.agri_fields?.map(af => af.id)
            this.plantingDetail.work_end_date = target.value
            if (this.plantingDetail.work_start_date && this.plantingDetail.work_end_date && agriFields && agriFields.length !== 0) {
                this.updateUsingArea(agriFields, this.plantingDetail.work_start_date, this.plantingDetail.work_end_date)
            }
        }
        this.inputChanged()
    }

    private updateAreaRate(index: number, event: Event) {
        const target = event.target
        if(target instanceof HTMLInputElement && this.plantingDetail.agri_fields !== null) {
            const agriField = this.plantingDetail.agri_fields[index]
            const value = Number(target.value)
            const maxRate = Math.floor(this.areaValueToRate(agriField.planted_area, agriField.remaining_area))
            agriField.using_area = maxRate === value ? agriField.remaining_area : this.areaRateToValue(agriField.planted_area, value)
            this.usingAreaMessageList = this.usingAreaMessageList.filter(uam => uam.id !== agriField.id)
        }
    }

    private updateAreaValue(index: number, event: Event) {
        const target = event.target
        if(target instanceof HTMLInputElement && this.plantingDetail.agri_fields !== null) {
            const agriField = this.plantingDetail.agri_fields[index]
            const usingArea = Number(target.value)
            this.usingAreaMessageList = this.usingAreaMessageList.filter(uam => uam.id !== agriField.id)
            this.checkArea(agriField, usingArea)
        }
    }

    private checkArea(agriField: AgriFieldOnPlantingResponse, usingArea: number) {
        if(agriField.remaining_area < usingArea) {
            const message = `${agriField.name}における利用面積が圃場の空き面積を超えています`
            const usingAreaMessage = {id: agriField.id, message}
            this.usingAreaMessageList.push(usingAreaMessage)
        }
    }

    private validateArea(usingArea: string, remainingArea: string): boolean {
        return Number(remainingArea) < Number(usingArea);
    }

    private async getRemainingAreas(agriFields: string[], workStartDate: string, workEndDate: string) {
        if (agriFields.length !== 0) {
            const agriFieldsParam = 'agri_fields=' + agriFields.reduce((paramStr, af) => `${paramStr}&agri_fields=${af}`)
            const workStartDateParam = `work_start_date=${workStartDate}`
            const workEndDateParam = `work_end_date=${workEndDate}`
            const excludePlantingParam = this.modeType === 'edit' && this.editTargetId !== '' ? `exclude_planting_id=${this.editTargetId}` : ''
            const uri = `/agri_fields/remaining_areas?${agriFieldsParam}&${workStartDateParam}&${workEndDateParam}&${excludePlantingParam}`
            const encodedUri = encodeURI(uri)
            const resAgriFields: AgriFieldOnPlantingResponse[] = await this.$apiClient.doRequest('get', encodedUri)
            return resAgriFields
        } else {
            return []
        }
    }

    private async clearUsingArea(agriFields: string[], workStartDate: string, workEndDate: string) {
        const resAgriFields = await this.getRemainingAreas(agriFields, workStartDate, workEndDate)
        const newAgriFields = resAgriFields.map(af => ({...af, using_area: 0}))
        if(this.plantingDetail.agri_fields === null) {
            this.plantingDetail.agri_fields = []
        }
        this.plantingDetail.agri_fields?.splice(0, this.plantingDetail.agri_fields.length)
        this.plantingDetail.agri_fields?.push(...newAgriFields)
        this.usingAreaMessageList = []
    }

    private async updateUsingArea(agriFields: string[], workStartDate: string, workEndDate: string) {
        const newAgriFields = await this.getRemainingAreas(agriFields, workStartDate, workEndDate)
        if(this.plantingDetail.agri_fields === null) {
            this.plantingDetail.agri_fields = []
        }
        this.usingAreaMessageList = []
        newAgriFields.forEach((naf, index) => {
            const oldAgriField = this.plantingDetail.agri_fields?.find(oaf => oaf.id === naf.id)
            const usingArea = oldAgriField
                ? oldAgriField.using_area
                : 0
            const usingSeedlings =  oldAgriField  ? oldAgriField.using_seedlings : 0;
            const isDeletable = oldAgriField ? oldAgriField.isDeletable : true
            newAgriFields[index] = {...naf, using_area: usingArea, isDeletable: isDeletable , using_seedlings : usingSeedlings }
            this.checkArea(naf, usingArea)
        })
        this.plantingDetail.agri_fields?.splice(0, this.plantingDetail.agri_fields.length)
        this.plantingDetail.agri_fields?.push(...newAgriFields)
        this.plantingDetail.agri_fields.sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    private dateFormatCheck(date: string | null) {
        const regex = new RegExp(/^\d{4}-\d{2}-\d{2}$/)
        return date !== null && regex.test(date)
    }

    @Emit('inputChanged')
    inputChanged(){
        if(store.getters.isInputChanged==false){
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    
    private handlePlantedarea(index: number){
        const agriFields = this.plantingDetail.agri_fields;
        if (!agriFields || index < 0 || index >= agriFields.length) {
            return;
        }
        const agriFieldId = agriFields[index].id;
        
        if (!this.changedAgriFieldIds.includes(agriFieldId)) {
            this.changedAgriFieldIds.push(agriFieldId);
        }
        
        this.workRecordCultivationRecordFlag = agriFields.some(field =>
        this.changedAgriFieldIds.includes(field.id) &&
        field.isDeletable === false
    );
        this.inputChanged();
    }
}